@if (isReady && form) {
  @for (field of forms[0].inputs; track field; let last = $last; let index = $index) {
    @if (field?.type == 'text') {
      <tidy-row style="margin-bottom: 5px">
        <form [formGroup]="form">
          <tidy-input
            [label]="field?.label"
            [formControlName]="field?.id?.toString()"
            [form]="getFormControl(field?.id?.toString())"
            [submitted]="shouldShowFieldError(field?.id?.toString())"
            [errorMessage]="'Please enter an answer.'"
            [icon]="'assets/svg/information-circle.svg'" />
        </form>
      </tidy-row>
    }
    @if (field?.type == 'text_area') {
      <tidy-row  style="margin-bottom: 5px">
        <form [formGroup]="form">
          <tidy-textarea
            [label]="field?.label"
            [formControlName]="field?.id?.toString()"
            [form]="getFormControl(field?.id?.toString())"
            [submitted]="shouldShowFieldError(field?.id?.toString())"
            [errorMessage]="'Please enter an answer.'"
            [icon]="'assets/svg/information-circle.svg'" />
        </form>
      </tidy-row>
    }
    @if (field?.type == 'select' && field?.data?.type !== 'image') {
      <tidy-row  style="margin-bottom: 5px">
        <form [formGroup]="form">
          <tidy-radio-button
            [label]="field?.label"
            [form]="getFormControl(field?.id?.toString())"
            (optionChange)="changeSelectValue($event, index)"
            [formControlName]="field?.id?.toString()"
            [items]="field?.items"
            [submitted]="shouldShowFieldError(field?.id?.toString())"
            [errorMessage]="'Please enter an answer.'" />
        </form>
      </tidy-row>
    }
    @if (field?.type == 'multi_select') {
      <div [ngClass]="{'extra-bottom-padding': !last}">
        <tidy-row class="vertical-align-center" style="margin-bottom: 5px">
          <tidy-text
            [body]="field?.label" />
        </tidy-row>
        <tidy-row>
          @for (checkbox of field?.data?.options; track checkbox) {
            <tidy-checkbox
              [items]="[{value: checkbox.key, viewValue: checkbox.label}]"
              (checkedChange)="selectCheckbox($event, checkbox, field, index)" />
          }
        </tidy-row>
      </div>
    }
    @if (forms[0]?.inputs[index]?.requiresTextArea) {
      <tidy-row  style="margin-bottom: 5px">
        <form [formGroup]="form">
          <tidy-textarea
            [label]="'Other'"
            [formControlName]="field?.id?.toString() + 'textArea'"
            [form]="getFormControl(field?.id?.toString() + 'textArea')"
            [submitted]="shouldShowFieldError(field?.id?.toString() + 'textArea')"
            [errorMessage]="'Please enter an answer.'"
            [icon]="'assets/svg/information-circle.svg'" />
        </form>
      </tidy-row>
    }
    @if (field?.data?.type == 'image') {
      <tidy-row  style="margin-bottom: 5px">
        <tidy-row>
          <tidy-text
            [body]="field?.label" /><br>
          @if (!getAttachment(field)) {
            <tidy-text
              [actionBody]="'Add Image'"
              (action)="addAttachment(field)"
              class="white-link" />
          }
        </tidy-row>
        @if (getAttachment(field)) {
          <tidy-two-column-row  style="margin-bottom: 5px">
            <tidy-text
              [body]="getAttachment(field)?.fileName" />
            <tidy-text
              [actionBody]="'remove'"
              (action)="removeAttachment(field)"
              class="link red" />
          </tidy-two-column-row>
        }
        @if (forms[0]?.inputs[index]?.imageUploadError && submitted && hasImageUploadError) {
          <tidy-error-message
            [text]="'Please upload an image'" />
        }
      </tidy-row>
    }
    @if (field?.data?.type == 'images') {
      <tidy-row  style="margin-bottom: 5px">
        <tidy-row>
          <tidy-text
            [body]="field?.label" /><br>
        </tidy-row>
        @for (imageUrl of getAttachment(field)?.value; track imageUrl) {
          <tidy-two-column-row>
            <tidy-text
              [body]="imageUrl | urlFileName" />
            <tidy-text
              [actionBody]="'remove'"
              (action)="removeAttachment(field, imageUrl)"
              class="link red" />
          </tidy-two-column-row>
        }
        <tidy-row style="margin-bottom: 5px">
          <tidy-text
            [actionBody]="'Add Images'"
            (action)="addAttachment(field);"
            class="white-link" />
        </tidy-row>
        @if (forms[0]?.inputs[index]?.imageUploadError && submitted && hasImageUploadError) {
          <tidy-error-message
            [text]="'Please upload an image'" />
        }
      </tidy-row>
    }
  }
}

<!-- Loading state with Ionic skeleton fields -->
@if (isLoading) {
  <div class="skeleton-loading">
    <!-- Simulate multiple form fields with varying types -->
    <tidy-row class="skeleton-row">
      <ion-skeleton-text animated style="width: 100%; height: 60px; border-radius: 6px;" />
    </tidy-row>
    <tidy-row class="skeleton-row">
      <ion-skeleton-text animated style="width: 100%; height: 60px; border-radius: 6px;" />
    </tidy-row>
    <tidy-row class="skeleton-row">
      <ion-skeleton-text animated style="width: 100%; height: 60px; border-radius: 6px;" />
    </tidy-row>
    <tidy-row class="skeleton-row">
      <ion-skeleton-text animated style="width: 100%; height: 60px; border-radius: 6px;" />
    </tidy-row>
  </div>
}

<!-- Error message display -->
@if (errorMessage) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
}
